import React from 'react';

import { AGENT_DETAIL_FIELD_LABELS } from 'types';

import { SummaryRow } from '../../Summary/SummaryRow';
import { useAuth } from '../../../hooks/useAuth';
import { formatAgentCompanyName } from '../../pages/dashboard/info/fieldData';
import { useTranslation } from "react-i18next";

interface Props {
  displayName: string;
  importAgentName?: string;
  agentFamilyName: string;
  agentGivenName: string;
  branchAddressLine1: string;
  branchAddressLine2: string;
  branchAddressLine3: string;
  branchCity: string;
  branchCountry: string;
  branchPostcode: string;
}

export default function AgentDetailsSummary(props: Props): React.ReactElement {
    const { t } = useTranslation('forms.visa');
  const { isAgent } = useAuth();
  const agentCompanyName = formatAgentCompanyName(props.displayName, props.importAgentName);
  return (
    <>
      {!isAgent && <SummaryRow label={t('forms.visa:agentCompanyName')} value={agentCompanyName} />}
      <SummaryRow
        label={AGENT_DETAIL_FIELD_LABELS.agentFamilyName}
        value={props.agentFamilyName || '<no data provided>'}
      />
      <SummaryRow
        label={AGENT_DETAIL_FIELD_LABELS.agentGivenName}
        value={props.agentGivenName || '<no data provided>'}
      />
      <SummaryRow label={t('forms.visa:branchAddressLine1')} value={props.branchAddressLine1 || '<no data provided>'} />
      <SummaryRow label={t('forms.visa:branchAddressLine2')} value={props.branchAddressLine2 || '<no data provided>'} />
      <SummaryRow label={t('forms.visa:branchAddressLine3')} value={props.branchAddressLine3 || '<no data provided>'} />
      <SummaryRow label={t('forms.visa:branchCity')} value={props.branchCity || '<no data provided>'} />
      <SummaryRow label={t('forms.visa:branchCountry')} value={props.branchCountry || '<no data provided>'} />
      <SummaryRow label={t('forms.visa:branchPostcode')} value={props.branchPostcode || '<no data provided>'} />
    </>
  );
}
